import { render, staticRenderFns } from "./search-statement.vue?vue&type=template&id=2438d863&scoped=true&"
import script from "./search-statement.vue?vue&type=script&lang=js&"
export * from "./search-statement.vue?vue&type=script&lang=js&"
import style0 from "./search-statement.vue?vue&type=style&index=0&id=2438d863&prod&scoped=true&lang=css&"
import style1 from "./search-statement.vue?vue&type=style&index=1&id=2438d863&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438d863",
  null
  
)

export default component.exports